import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import LoadingScreen from 'src/screens/Loading';
import { useSamlExchangeMutation } from 'src/services/auth/api';
import { ssoLogin } from 'src/services/auth/slice';
import { useDispatch } from 'src/services/redux';

const SsoCallback: FC = () => {
  const [params] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [samlExchange] = useSamlExchangeMutation();

  useEffect(() => {
    const handleSsoCallback = async () => {
      const code = params.get('code');
      if (!code) {
        navigate('/auth/login', { replace: true });
        return;
      }

      try {
        const data = await samlExchange(code).unwrap();
        dispatch(ssoLogin({ accessToken: data.accessToken, refreshToken: data.refreshToken, mustSetPassword: data.mustSetPassword, privacyPolicyAccepted: data.privacyPolicyAccepted }));
        navigate('/', { replace: true });
      } catch {
        navigate('/auth/login', { replace: true });
      }
    };

    handleSsoCallback();
  }, []);

  return <LoadingScreen />;
};

export default SsoCallback;
